export const KEY = 'categoryReview'
export const REVIEW_MODAL_NAME = 'modal-add-review'
export const DEFAULT_PAGE_SIZE = 3

// Kept in step with Magebit\Review\Model\CategoryReviewValidator on the Magento side
export const MAX_NICKNAME_LENGTH = 128
export const MAX_TITLE_LENGTH = 255
export const MAX_DETAIL_LENGTH = 5000
